import { ToolbarConfig } from '@tencent/workbench';
import i18n from '@i18next/i18n';
import { ActionType } from '@editor/src/js/constants/common-action-type';

export const config = {
    id: ActionType.ANIM_ENTR,
    content: i18n.t('进入动画'),
};

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        preventHighlight: true,
        shrinkable: 'steps',
        shrinkSteps: [244, 314],
        widthRange: [174, 384],
    },
];
